import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, switchMap } from 'rxjs';
import { AuthService } from '@app/shared/services/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class JwtInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return this.authService.getAuthorizationHeaderValue$()
      .pipe(
        switchMap(authorizationHeaderValue => {
          if (authorizationHeaderValue) {
            request = request.clone({
              setHeaders: {
                // eslint-disable-next-line @typescript-eslint/naming-convention
                Authorization: authorizationHeaderValue
              }
            });
          }
          return next.handle(request);
        })
      );
  }
}
